/*eslint  @typescript-eslint/no-use-before-define: 0*/

import { defineModule } from "direct-vuex";
import { moduleActionContext, moduleGetterContext } from "@/store";
import { DataOptions } from "vuetify/types";
import { DefaultDataOptions } from "@/models/components/dataTables/DataTableOptions";
import CreditCardStatement from "@/models/api/finances/CreditCardStatementsListItem";
import { FILTER_NAMES } from "@/static/filterNames";
import { getCreditCardStatementsTable, getCreditCardStatement } from "@/requests/finances";
import CriterionItemRequest from "@/models/api/filters/criterions/CriterionItemRequest";
import CreditCardStatementItem from "@/models/api/finances/CreditCardStatementListItem";

export interface CreditCardStatementsStateInterface {
  isCreditCardStatementsDataLoading: boolean;
  creditCardStatementsOptions: DataOptions;
  creditCardStatementsData: Array<CreditCardStatement>;
  creditCardStatementsCount: number | null;
  creditCardStatementsFilter: Array<CriterionItemRequest> | null;

  isCreditCardStatementItemsDataLoading: boolean;
  creditCardStatementItemsOptions: DataOptions;
  creditCardStatementItemsData: Array<CreditCardStatementItem>;
  creditCardStatementItemsCount: number | null;
  creditCardStatementItemsFilter: Array<CriterionItemRequest> | null;
  statementId: number | null;
  statementNumber: string | null;
}

export const CreditCardStatementsState: CreditCardStatementsStateInterface = {
  isCreditCardStatementsDataLoading: false,
  creditCardStatementsOptions: new DefaultDataOptions(),
  creditCardStatementsData: [],
  creditCardStatementsCount: null,
  creditCardStatementsFilter: null,

  isCreditCardStatementItemsDataLoading: false,
  creditCardStatementItemsOptions: new DefaultDataOptions(),
  creditCardStatementItemsData: [],
  creditCardStatementItemsCount: null,
  creditCardStatementItemsFilter: null,
  statementId: null,
  statementNumber: null,
};

const CreditCardStatementsModule = defineModule({
  state: CreditCardStatementsState as CreditCardStatementsStateInterface,
  namespaced: true as const,
  getters: {},
  mutations: {
    setIsCreditCardStatementsDataLoading(state, param: boolean) {
      state.isCreditCardStatementsDataLoading = param;
    },
    setCreditCardStatementsOptions(state, param: DataOptions) {
      state.creditCardStatementsOptions = param;
    },
    setCreditCardStatementsData(state, param: Array<CreditCardStatement>) {
      state.creditCardStatementsData = param;
    },
    setCreditCardStatementsCount(state, param: number) {
      state.creditCardStatementsCount = param;
    },
    setCreditCardStatementsFilter(state, param: Array<CriterionItemRequest> | null) {
      state.creditCardStatementsFilter = param;
    },
    setIsCreditCardStatementItemsDataLoading(state, param: boolean) {
      state.isCreditCardStatementItemsDataLoading = param;
    },
    setCreditCardStatementItemsOptions(state, param: DataOptions) {
      state.creditCardStatementItemsOptions = param;
    },
    setCreditCardStatementItemsData(state, param: Array<CreditCardStatementItem>) {
      state.creditCardStatementItemsData = param;
    },
    setCreditCardStatementItemsCount(state, param: number) {
      state.creditCardStatementItemsCount = param;
    },
    setCreditCardStatementItemsFilter(state, param: Array<CriterionItemRequest> | null) {
      state.creditCardStatementItemsFilter = param;
    },
    setOpenedCreditCardStatement(state, param: CreditCardStatement | null) {
      if (param != null) {
        state.statementId = param.id;
        state.statementNumber = param.statementNumber;
      } else {
        state.statementId = null;
        state.statementNumber = null;
      }
    },
  },
  actions: {
    async getCreditCardStatementsTable(context) {
      const { commit, state } = _moduleActionContext(context);
      commit.setIsCreditCardStatementsDataLoading(true);
      const response = await getCreditCardStatementsTable({
        count: state.creditCardStatementsOptions.itemsPerPage,
        page: state.creditCardStatementsOptions.page - 1,
        criterions: state.creditCardStatementsFilter,
        filterName: FILTER_NAMES.CreditCardStatementsFilter,
      });
      commit.setCreditCardStatementsData(response.items);
      commit.setCreditCardStatementsCount(response.totalCount);
      commit.setIsCreditCardStatementsDataLoading(false);
    },
    async getCreditCardStatementItems(context): Promise<void> {
      const { commit, state } = _moduleActionContext(context);
      if (state.statementId !== null) {
        commit.setIsCreditCardStatementItemsDataLoading(true);
        const response = await getCreditCardStatement(state.statementId, {
          count: state.creditCardStatementItemsOptions.itemsPerPage,
          page: state.creditCardStatementItemsOptions.page - 1,
          criterions: state.creditCardStatementItemsFilter,
          filterName: FILTER_NAMES.CreditCardStatementItemsFilter,
        });
        commit.setCreditCardStatementItemsData(response.items);
        commit.setCreditCardStatementItemsCount(response.totalCount);
        commit.setIsCreditCardStatementItemsDataLoading(false);
      }
    },
  },
});

export default CreditCardStatementsModule;

/* eslint-disable */
// noinspection JSUnusedLocalSymbols
const _moduleGetterContext = (args: [any, any, any, any]) =>
  moduleGetterContext(args, CreditCardStatementsModule);
const _moduleActionContext = (context: any) =>
  moduleActionContext(context, CreditCardStatementsModule);
